function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.677083,
  y: 0.677083,
  width: 4.27917,
  height: 1.67917,
  stroke: "#DDDDDD",
  strokeWidth: 1.35417
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.04427,
  y: 0.677083,
  width: 4.27917,
  height: 5.14583,
  stroke: "#DDDDDD",
  strokeWidth: 1.35417
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.04427,
  y: 8.91048,
  width: 4.27917,
  height: 3.4125,
  stroke: "#DDDDDD",
  strokeWidth: 1.35417
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 0.677083,
  y: 5.44368,
  width: 4.27917,
  height: 6.87917,
  stroke: "#DDDDDD",
  strokeWidth: 1.35417
});

var SvgOrgDashboard = function SvgOrgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/org-dashboard.656431e6.svg";
export { ForwardRef as ReactComponent };